
import moment from 'moment';
import { PeriodHelper } from 'src/app/core/helpers/period.helper';

import { NewPeriodSelectorInterval } from 'src/app/core/enums/newPeriodSelectorInterval';
import { NewCalendarPeriodFilter } from 'src/app/core/models/period-selector/newCalendarPeriodFilter';
import { NewCalendarPeriodSelectorItem } from './base/new-calendar-period-selector-item';
import { Constants } from 'src/app/core/constants';

export class FourWeekPeriodSelectorItem extends NewCalendarPeriodSelectorItem {
  interval = NewPeriodSelectorInterval.FourWeek;
  hasNavigation = true;

  constructor(name: string) {
    super(name);
  }

  getPeriodFilter = () => {
    let endDate: Date;
    const currentDate = moment().startOf('day').toDate();
    endDate = currentDate;

    const weekNumberAndYear = PeriodHelper.getWeekNumberAndYear(endDate);
    let ratio = weekNumberAndYear.weekNumber / 4;
    ratio = Math.trunc(ratio);
    let remainder = weekNumberAndYear.weekNumber % 4;
    remainder = Math.trunc(remainder);
    let firstWeekOfThePeriod;
    if (remainder === 0) {
      firstWeekOfThePeriod = 4 * (ratio - 1) + 1;
    } else {
      firstWeekOfThePeriod = 4 * ratio + 1;
    }
    const firstDayOfTheWeek = PeriodHelper.getDateOfISOWeek(
      firstWeekOfThePeriod,
      weekNumberAndYear.yearNumber
    );
    const startDate = moment(firstDayOfTheWeek).startOf('day').toDate();
    endDate = moment(endDate).endOf('day').toDate();

    const periodFilter = new NewCalendarPeriodFilter();
    periodFilter.startDate = startDate;
    periodFilter.endDate = endDate;
    periodFilter.periodInterval = NewPeriodSelectorInterval.FourWeek;

    return periodFilter;
  }

  getPreviousPeriodFilter = (currentFilter: NewCalendarPeriodFilter) => {
    let newStartDate = new Date();
    let newEndDate = moment(currentFilter.startDate)
      .add(-1, 'day')
      .toDate();
    const lastWeekOfThePeriod = PeriodHelper.getWeekNumberAndYear(
      newEndDate
    );
    let firstDayOfFirstWeekOfThePeriod = PeriodHelper.getDateOfISOWeek(
      lastWeekOfThePeriod.weekNumber - 3,
      lastWeekOfThePeriod.yearNumber
    );
    if (PeriodHelper.IsLastWeekOfTheYear(lastWeekOfThePeriod.weekNumber)) {
      firstDayOfFirstWeekOfThePeriod = PeriodHelper.getDateOfISOWeek(
        Constants.LAST_4WEEKS_PERIOD_OF_THE_YEAR_START_WEEK,
        lastWeekOfThePeriod.yearNumber
      );
    }
    newStartDate = moment(firstDayOfFirstWeekOfThePeriod)
      .startOf('day')
      .toDate();
    newEndDate = moment(newEndDate).endOf('day').toDate();

    const periodFilter = new NewCalendarPeriodFilter();
    periodFilter.startDate = newStartDate;
    periodFilter.endDate = newEndDate;
    periodFilter.periodInterval = NewPeriodSelectorInterval.FourWeek;

    return periodFilter;
  }

  getNextPeriodFilter = (currentFilter: NewCalendarPeriodFilter) => {
    const newStartDate = moment(currentFilter.endDate).add(1, 'day').startOf('day').toDate();
    let newEndDate = moment(newStartDate).endOf('month').toDate();

    const lastWeekOfThePeriod = PeriodHelper.getWeekNumberAndYear(
      newStartDate
    );
    if (lastWeekOfThePeriod.weekNumber === Constants.LAST_4WEEKS_PERIOD_OF_THE_YEAR_START_WEEK) {
      const lastWeekNumberOfYear = PeriodHelper.getLastWeekNumberOfYear(lastWeekOfThePeriod.yearNumber);
      lastWeekOfThePeriod.weekNumber = lastWeekNumberOfYear.weekNumber;
      lastWeekOfThePeriod.yearNumber = lastWeekNumberOfYear.yearNumber;
    } else {
      lastWeekOfThePeriod.weekNumber = lastWeekOfThePeriod.weekNumber + 3;
    }

    const firstDayOfFirstWeekOfThePeriod = PeriodHelper.getDateOfISOWeek(
      lastWeekOfThePeriod.weekNumber,
      lastWeekOfThePeriod.yearNumber
    );
    newEndDate = moment(firstDayOfFirstWeekOfThePeriod)
      .endOf('isoWeek')
      .toDate();
    newEndDate = moment(newEndDate)
      .endOf('day')
      .toDate();

    if (moment(newEndDate).endOf('day') > moment().endOf('day')) {
      newEndDate = moment().endOf('day').toDate();
    }

    const periodFilter = new NewCalendarPeriodFilter();
    periodFilter.startDate = newStartDate;
    periodFilter.endDate = newEndDate;
    periodFilter.periodInterval = NewPeriodSelectorInterval.FourWeek;

    return periodFilter;
  }
}
